import { get as restMethodGet } from "@stubhub/rest-method";

import { SEARCH_CACHE_MAX_AGE } from "./constants";

const API_HOST = process.env.REACT_APP_API_HOST;

const _headers = {
  "Accept-Language": "en-us",
};
const _auth = {
  Authorization: process.env.REACT_APP_API_SECRET,
};

function getRequestHeaderSettings(headers, omitAuth) {
  return { ..._headers, ...(omitAuth ? null : _auth), ...headers };
}

export const get = (options = {}) => {
  let {
    host,
    path,
    json,
    logger,
    query,
    body,
    timeout,
    headers,
    auth,
    cache = false,
    cacheMaxAge,
    proxy,
  } = options;
  if (/^http/i.test(path)) {
    host = undefined;
  } else {
    host = host || API_HOST;
  }

  headers = getRequestHeaderSettings(headers, auth === false);

  return restMethodGet({
    host,
    path,
    json,
    logger,
    query,
    body,
    timeout,
    headers,
    cache,
    cacheMaxAge,
    proxy,
  });
};

export const getJSON = (options = {}) => {
  options.json = true;

  return get(options);
};

/**
 * Method to Fetch the Event from Search Catalog Events API. Please refer to the link below for the detailed documentation for this API.
 * @link https://wiki.stubcorp.com/pages/viewpage.action?pageId=20354722
 *
 */
export const searchEvents = (
  {
    associatedEvents,
    shstore = 1,
    id,
    performerId,
    geoId,
    categoryId,
    groupingId,
    venueId,
    dateLocal,
    date,
    units,
    parking,
    sourceId = "0 |1 |4001 |5001",
    status = "active |contingent",
    start = 0,
    rows = 20,
    spellCheck = true,
    geoExpansion = true,
    boostByCategory = true,
    lang = true,
    includeNonEventEntities = true,
    edgeControlEnabled = true,
    sort = "eventDateLocal asc",
    reRankBy = "relevance",
    improvedRelevancy = true,
    term,
    q,
    point,
    radius,
    excludeFromRadius = false,
    fieldList = "id,ticketInfo,name,eventDateLocal,categories,groupings,performers,venue,eventInfoUrl,displayAttributes,description,imageUrl,createdDate,performersCollection,eventType,urgencyMessage,metaInfo",
    logger,
    gameType,
    eventType,
    aggFields,
    aggLimit,
    eventMonth,
    dayAndTime,
    performerRole,
    disableUrgency = false,
  },
  locale
) => {
  /**
   * Associated Events
   *
   */
  if (associatedEvents) {
    fieldList += ",associatedEvents";
  }

  /**
   * Remove urgency if its Disabled
   *
   */
  if (disableUrgency && fieldList) {
    fieldList = fieldList.replace(",urgencyMessage", "");
  }

  /**
   * Enforcing Default Search Radius when location is set.
   *
   */
  if (point) {
    radius = radius || 200;
    geoExpansion = false;
  }

  const params = {
    shstore,
    status,
    spellCheck,
    boostByCategory,
    lang,
    includeNonEventEntities,
    edgeControlEnabled,
    fieldList,
    sourceId,
    parking,

    /**
     * Geo-location
     *
     */
    point,
    radius,
    excludeFromRadius,
    units,
    geoExpansion,

    /**
     * Pagination
     *
     */
    start,
    rows,

    /**
     * Date Filters
     *
     */
    dateLocal,
    date,

    /**
     * Sort params
     *
     */
    sort,
    reRankBy,
    improvedRelevancy,

    /**
     * Filter And Facets Params
     *
     */
    gameType,
    eventType,
    aggFields,
    aggLimit,
    eventMonth,
    dayAndTime,
    performerRole,

    /**
     * Main Search Criteria
     * Note - Only One of these should be passed at time, Passing two or more might result in Zero results.
     *
     */
    id,
    performerId,
    geoId,
    categoryId,
    groupingId,
    venueId,
    q: q || term,
  };

  return getJSON({
    path: "/search/catalog/events/v3",
    query: params,
    logger,
    headers: { "Accept-Language": locale },
    cache: true,
    cacheMaxAge: SEARCH_CACHE_MAX_AGE,
  });
};
